import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SuccessModalHelperService } from '../_helpers/success-modal-helper/success-modal-helper.service';
import {Location} from '@angular/common';
import { ExternalSitesService } from '../_services/external-sites/external-sites.service';
import { SecureLinkRetrievalResponse } from '../_models/external-sites/secure-link-retrieval-response.model';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';

@Component({
    selector: 'app-iframe-wrapper',
    templateUrl: './iframe-wrapper.component.html',
    styleUrls: ['./iframe-wrapper.component.css'],
    standalone: false
})
export class IframeWrapperComponent implements OnInit {

  private unsubscribe: Subject<void> = new Subject<void>();

  public isError: boolean = false;
  public secureLink: string;

  public requestToken: string;

  constructor(
    private route: ActivatedRoute,
    // public themeService: ThemeService,
    private successModalHelper: SuccessModalHelperService,
    private location: Location,
    private externalSiteService: ExternalSitesService,
    private errorModalHelper: ErrorModalHelperService

  ) { 
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
      // used for unauthenticated response from sso
      if (params['guid'] != null && params['guid'] == "unauthorized") {
        this.errorModalHelper.show("Your login attempt has failed. Please try again or contact the system administrator.", {isValidationError: false});
        this.isError =true;
      } else {
        this.requestToken = params['guid'];
        setTimeout(() => {
          this.validateRequest();
        }, 0);
      }
    });
  }

  ngOnInit() {
  }

  public navBack(): void {
    this.location.back();
  }

  private validateRequest(): void {
    this.externalSiteService.secureLinkRetrieval(this.requestToken).subscribe((response: SecureLinkRetrievalResponse) => {
      this.secureLink = response.linkUrl;
    }, error => {
      console.error(error);
      this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", error);
    });
  }

}
